/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import messages from './messages';
import { escTextStyles } from './styles';
import { buttonAutoFocusRingFix } from '../../styles/focus';
export const CancelEscButton = ({
  onCancel,
  autoFocus
}) => {
  const {
    formatMessage
  } = useIntl();
  return jsx(Button, {
    css: buttonAutoFocusRingFix,
    autoFocus: autoFocus,
    testId: "cancel-esc-button",
    type: "button",
    onClick: onCancel
  }, formatMessage(messages.labelCancel), jsx("span", {
    css: escTextStyles
  }, formatMessage(messages.labelEsc)));
};